const PropertyType = Object.freeze({
  HOUSE: 'HOUSE',
  APARTMENT: 'APARTMENT',
  MULTI_FAMILY_HOUSE: 'MULTI_FAMILY_HOUSE'
})

export default PropertyType
